// removed by extract-text-webpack-plugin
module.exports = {"titleRow":"_1IT3xVVKQLfUBvNrItq7TW","titleWrapper":"V8eRP1Pjab0kdziAKERuT","chip":"_3YJO3zxuVjeefvniMu8lbP","title":"vYSb_rT8L9PwnUE9zlWJZ","content":"_2cnNqOYQSn5ZDqFbAzgO6A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hidable/styles.css
// module id = 1073
// module chunks = 0